import _ from "lodash";

const userIsAuthorized = (userRoles, authorizedRoles) => {
    return _.intersection(userRoles, authorizedRoles).length > 0 || userRoles.indexOf("superAdmin") > -1;
}

export default userIsAuthorized;
